
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/orgs/new",
      function () {
        return require("private-next-pages/orgs/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/orgs/new"])
      });
    }
  